const certifications = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: '이노비즈 / 메인비즈',
    description: '기술/경영 혁신형 중소기업 인증으로 금융 우대 및 정부 지원사업 가점을 받을 수 있습니다.',
    benefits: ['금융 우대 혜택', '정부 지원사업 가점', '기업 신뢰도 향상', '세제 혜택']
  },
  {
    icon: 'ri-rocket-2-line',
    title: '벤처기업인증',
    description: '세제 감면 및 투자 유치를 위한 필수 인증으로 스타트업 성장의 발판을 마련합니다.',
    benefits: ['세제 감면', '투자 유치 용이', '정부 지원 우대', '인력 채용 지원']
  },
  {
    icon: 'ri-plant-line',
    title: '녹색인증',
    description: '탄소중립 기술력 증명 및 조달 가점 확보로 ESG 경영을 실현합니다.',
    benefits: ['조달 가점', 'ESG 경영 강화', '친환경 기업 이미지', '정부 지원 우선']
  },
  {
    icon: 'ri-star-line',
    title: 'NET & NEP',
    description: '신기술/신제품 인증을 통한 공공 판로 개척으로 매출 확대 기회를 제공합니다.',
    benefits: ['공공 조달 우선', '기술력 인정', '마케팅 효과', '수출 지원']
  }
];

export default function ManagementCertification() {
  return (
    <section id="management-certification" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            경영 인증
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            기업의 경쟁력을 높이는 경영시스템 인증
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-10 md:mb-16">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-6 md:p-8 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 cursor-pointer group"
            >
              <div className="flex items-start gap-4 md:gap-6">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-500 transition-colors">
                  <i className={`${cert.icon} text-2xl md:text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-3 leading-tight">{cert.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">{cert.description}</p>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3">
                    {cert.benefits.map((benefit, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <i className="ri-checkbox-circle-fill text-teal-600 flex-shrink-0"></i>
                        <span className="text-xs md:text-sm text-gray-700">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-white">
          <div className="text-center mb-8 md:mb-10">
            <h3 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4 leading-tight">경영 인증의 주요 혜택</h3>
            <p className="text-white/90 text-base md:text-lg">
              정부 지원과 세제 혜택으로 기업의 성장을 가속화하세요
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className="ri-funds-line text-3xl md:text-4xl"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold mb-2">금융 지원</h4>
              <p className="text-white/90 text-sm md:text-base leading-relaxed">정책자금 융자 및 금리 우대 혜택</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className="ri-percent-line text-3xl md:text-4xl"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold mb-2">세제 혜택</h4>
              <p className="text-white/90 text-sm md:text-base leading-relaxed">법인세 및 소득세 감면 혜택</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className="ri-government-line text-3xl md:text-4xl"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold mb-2">정부 지원</h4>
              <p className="text-white/90 text-sm md:text-base leading-relaxed">R&D 과제 및 지원사업 가점</p>
            </div>
          </div>

          <div className="text-center mt-8 md:mt-10">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-100 transition-all shadow-lg cursor-pointer whitespace-nowrap text-sm md:text-base"
            >
              경영 인증 상담받기
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
